/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentsResponse } from '../../models/agents-response';

export interface GetAgents$Params {
}

export function getAgents(http: HttpClient, rootUrl: string, params?: GetAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getAgents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentsResponse>;
    })
  );
}

getAgents.PATH = '/agents';
